import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { usePracticeFieldsState, usePracticeFieldsDispatch } from '../../../store/hooks/practiceFields';

import { Col, Tab } from 'react-bootstrap';
import Loader from '../Loader';
import PracticeAreas from './PracticeAreas';
import {
  DEFAULT_PRACTICE_AREA_STATE,
  DEFAULT_PRACTICE_FIELD_ROUTE,
  DEFAULT_PRACTICE_AREA_FIELD_STATE,
  ADD_ACTION
} from '../../../config/constants';
import { isEmptyObject } from '../../../helpers/helpers';
import { PAContainer, Field, FormState, PracticeFieldsDispatch } from './types';

import './styles.scss';

const loaderProps = {
  style: { height: 'calc(100vh - 250px)' }
};

export default ({ teamsData }: PAContainer) => {

  const { fields: practiceFields = {}, actions: showArea = {} } = usePracticeFieldsState();
  const { loadPracticeFields, setPracticeFieldActions }: PracticeFieldsDispatch = usePracticeFieldsDispatch();

  const imageElement = useRef<any>();
  const { teamId } = useParams<{ teamId: string }>();
  const [field, setField] = useState<Field>(DEFAULT_PRACTICE_AREA_FIELD_STATE);
  const [formState, setFormState] = useState<FormState>(DEFAULT_PRACTICE_AREA_STATE);

  useEffect(() => {
    // load team fields when selecting
    loadPracticeFields(teamId);
    return () => setPracticeFieldActions({});
  }, [teamId]);

  const handleAddNewAreaBtn = () => {
    setPracticeFieldActions({ action: ADD_ACTION });
    setStateAsDefault();
    defaultFieldAsMap();
  };

  const setStateAsDefault = () => {
    if (imageElement.current) {
      const { naturalWidth, naturalHeight } = imageElement.current;
      setFormState({
        ...DEFAULT_PRACTICE_AREA_STATE,
        areaCoords: [0, 0, naturalWidth, naturalHeight],
        areaFeetDimensions: [naturalWidth, naturalHeight]
      });
    } else {
      setFormState(DEFAULT_PRACTICE_AREA_STATE);
    }
  };

  const defaultFieldAsMap = () => {
    fetch(DEFAULT_PRACTICE_FIELD_ROUTE)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], 'default.png', blob);
        setField({ image: DEFAULT_PRACTICE_FIELD_ROUTE, file }); // file only for default map
      });
  };

  return (
    <Col sm={9}>
      <Tab.Content>
        {teamsData.map(team => (
          <Tab.Pane eventKey={team.teamId} key={'tab-pane' + team.teamId}>
            <div className="customer-b-01 practice-areas">
              <div className="b-customer imagen-ll practice-areas-container">
                <div className="title-c">
                  <div className="team-tt">
                    <img src={`/assets/images/logos/${team.teamAbbrName}.png`} alt="" height="30px" />
                    {`${team.teamAbbrName} ${team.teamNick} — Practice Areas`}
                  </div>
                </div>
                <Loader {...loaderProps}>
                  <>
                    <div className="title-b add-btn-container">
                      <button className="btn-blue" onClick={handleAddNewAreaBtn}>
                        Add New Area
                      </button>
                    </div>
                    <div className="practice-areas-content">
                      {!isEmptyObject(practiceFields) || showArea.action ? (
                        <PracticeAreas
                          field={field}
                          setField={setField}
                          formState={formState}
                          imageElement={imageElement}
                          setFormState={setFormState}
                        />
                      ) : (
                        <div className="no-fields">
                          <h1>Please add a new Practice Area</h1>
                        </div>
                      )}
                    </div>
                  </>
                </Loader>
              </div>
            </div>
          </Tab.Pane>
        ))}
      </Tab.Content>
    </Col>
  );
};
